import { render, staticRenderFns } from "./CustomLogsTabbedPage.vue?vue&type=template&id=87f3f3f8&scoped=true"
import script from "./CustomLogsTabbedPage.vue?vue&type=script&lang=js"
export * from "./CustomLogsTabbedPage.vue?vue&type=script&lang=js"
import style0 from "./CustomLogsTabbedPage.vue?vue&type=style&index=0&id=87f3f3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f3f3f8",
  null
  
)

export default component.exports